/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CompletionDateOutput.vue?vue&type=template&id=713a4bf2"
import script from "./CompletionDateOutput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompletionDateOutput.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports